export const projectData = [
  {
    "image": "https://personal-website-assets104410-dev.s3.us-east-1.amazonaws.com/projects/kairis_reinoso.jpg",
    "info": {
      "projectName": "Kairis Reinoso",
      "duration": "August 2022- Now",
      "techStack": "React, AWS Amplify, DynamoDB, Lambda, SES",
    },
    "styles": {
      "imageHeight": "300",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://kairisreinoso.com",
    "attribute": "Web",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.us-east-1.amazonaws.com/projects/2.jpg",
    "info": {
      "projectName": "Adrian y Luisana Wedding",
      "duration": "August 2021 - March 2022",
      "techStack": "Vue, Netlify, DynamoDB, Lambda, SES",
    },
    "styles": {
      "imageHeight": "300",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://adrianyluisana.com",
    "attribute": "Web",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.us-east-1.amazonaws.com/projects/606.jpg",
    "info": {
      "projectName": "606 Studio",
      "duration": "July 2020 - Now",
      "techStack": "Wordpress",
    },
    "styles": {
      "imageHeight": "300",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://606-studio.com",
    "attribute": "Web",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/projects/smart-spaces.png",
    "info": {
      "projectName": "Smart Spaces",
      "duration": "January 2019 - Now",
      "techStack": "React Native, Redux, Raspberry Pi, Motion PIR sensor",
      "infraStack": "DynamoDB, Lambda Functions (Serverless Framework)",
      "extraInfo": "",
    },
    "styles": {
      "imageHeight": "500",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://github.com/edreinoso/smart-spaces",
    "attribute": "Native",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/projects/aws_dev_ops.png",
    "info": {
      "projectName": "Lambda Function Automation",
      "duration": "June 2019 - Now",
      "techStack": "Python3: Boto3 library",
      "infraStack": "Lambda, CloudWatch Events",
      "extraInfo": "",
    },
    "styles": {
      "imageHeight": "250",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://github.com/edreinoso/aws-devops",
    "attribute": "Cloud",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/projects/terraform.png",
    "info": {
      "projectName": "Terraform modules",
      "duration": "May 2019 - Now",
      "techStack": "Terraform",
      "infraStack": "S3 and DybamoDB as backend",
      "extraInfo": "",
    },
    "styles": {
      "imageHeight": "110",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://github.com/edreinoso/infrastructure-as-code",
    "attribute": "Cloud",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/projects/the_standard.jpg",
    "info": {
      "projectName": "The Standard",
      "duration": "August 2020 - September 2020",
      "techStack": "AWS",
      "infraStack": "EC2, ELB, AutoScaling, RDS",
      "extraInfo": "Leveraged AutoScaling and Elastic Load Balancer to handle the increased in user traffic",
    },
    "styles": {
      "imageHeight": "300",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://capemaystandard.com",
    "attribute": "Cloud",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/projects/react_native_auth_project.png",
    "info": {
      "projectName": "React Native Auth",
      "duration": "December 2019 - December 2019",
      "techStack": "React Native, Redux",
      "infraStack": "AWS Amplify, Google Firebase",
      "extraInfo": "",
    },
    "styles": {
      "imageHeight": "500",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://github.com/edreinoso/react-native-auth",
    "attribute": "Native",
  },
  {
    "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/projects/lazzaro.jpg",
    "info": {
      "projectName": "Lazzaro",
      "duration": "Mar 2018 - June 2019",
      "techStack": "Vue.js, Node.js",
      "infraStack": "RDS, Lambda Functions (Serverless Framework)",
      "extraInfo": "Collaborated in the frontend development of a crowdfunding platform in Spain.",
    },
    "styles": {
      "imageHeight": "300",
      "textJustified": "left",
      "textJustifiedC": "center",
    },
    "url": "https://fundraising.lazzaro.io/",
    "attribute": "Web",
  },
]

export default projectData